/**
 * EL PESO DOMINICANO SE ESCRIBE DE UNA SOLA FORMA — H69 (auditoría 16-sep-2026).
 *
 * En la misma sesión un pasajero veía "$250" al aceptar la oferta, "RD$ 250" en
 * su historial y "RD$250" en el recibo; el chofer veía su cuota en "DOP" y su
 * billetera en "RD$", y con 4 cifras el formato cambiaba ("RD$1050" contra
 * "RD$ 1,050"). No alteraba ningún cálculo, pero en el dinero se lee como
 * descuido.
 *
 * Una sola forma, la que ya dominaba y la que se entiende en la calle:
 * "RD$ 1,050" — con espacio, separador de miles dominicano y hasta 2 decimales
 * solo si los hay. Es SOLO presentación: nunca usar el resultado para calcular.
 */
/**
 * EL MISMO CRITERIO, PERO PARA CALCULAR.
 *
 * `pesos()` ya sabia distinguir "1,050" (miles) de "250,50" (decimal), pero
 * devuelve un texto y avisa de que no sirve para calcular. El criterio estaba
 * ahi dentro, atrapado, y por no tenerlo suelto `restaurant-dashboard.tsx`
 * escribio el suyo: `parseFloat(String(x).replace(',', '.'))`. Eso arregla el
 * decimal y ROMPE el millar — un plato de RD$1,500 tecleado "1,500" se guardaba
 * como RD$1.50, y el guardarrail no lo cazaba porque 1.5 es finito y mayor que
 * cero. Encontrado el 16-oct-2026.
 *
 * Reglas, en orden:
 *   "1,050" / "12,500.50"  la coma agrupa de tres en tres -> es de miles
 *   "1.500"                el punto agrupa de tres en tres -> es de miles
 *   "250,50" / "150.5"     cualquier otro caso -> es el decimal
 *
 * Devuelve NaN si no hay numero: quien llama decide que hacer, igual que antes.
 */
export function aMonto(valor: number | string | null | undefined): number {
  if (typeof valor === 'number') return valor;
  const t = String(valor ?? '').trim();
  if (!t) return NaN;
  // Coma de miles: 1-3 digitos y luego grupos de exactamente 3.
  if (/^\d{1,3}(,\d{3})+(\.\d+)?$/.test(t)) return Number(t.replace(/,/g, ''));
  // Punto de miles: lo mismo, y SIN decimales detras ("1.50" son 2 digitos, no 3).
  if (/^\d{1,3}(\.\d{3})+$/.test(t)) return Number(t.replace(/\./g, ''));
  return Number(t.replace(',', '.'));
}

export function pesos(monto: number | string | null | undefined): string {
  // Un solo criterio para leer un monto escrito a mano: ver `aMonto`.
  const n = aMonto(monto);
  const valor = Number.isFinite(n) ? Math.round(n * 100) / 100 : 0;
  return 'RD$ ' + valor.toLocaleString('es-DO', { maximumFractionDigits: 2 });
}
